import React, { useRef, useState } from 'react';
import BackgroundImg from '../../assets/trial_images/trialBackground.png';
import './Trial.scss';
import { Tabs, Row, Col } from 'antd';
import CustomerWX from './component/CustomerWX';
import TrialForm from './component/TrialForm';

const Trial = () => {
  const [activeKey, setActiveKey] = useState('1');
  const divStyle = {
    height: '100vh', // 高度为视口高度
    backgroundImage: `url(${BackgroundImg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };
  const renderTabBar = () => (
    <div
      style={{
        backgroundColor: 'rgba(227, 237, 253, 1)',
        borderTopLeftRadius: '16px',
        borderTopRightRadius: '16px',
        fontWeight: 600,
        position: 'relative',
      }}
    >
      <Row>
        <div
          className={'renderTabBarActStyle'}
          style={{
            left: activeKey === '1' ? 0 : '50%',
            width: '50%',
            height: '66px',
          }}
        />
        <Col style={{ zIndex: 2 }} span={12}>
          <div
            onClick={() => {
              setActiveKey('1');
            }}
            className={'renderTabBarStyle'}
            style={{
              textAlign: 'center',
              cursor: 'pointer',
              padding: '20px',
              fontSize: 16,
              zIndex: '3',
              color: activeKey === '1' ? 'rgba(40, 120, 255, 1)' : '',
            }}
          >
            申请试用
          </div>
        </Col>
        <Col style={{ zIndex: 2 }} span={12}>
          <div
            onClick={() => {
              setActiveKey('2');
            }}
            className={'renderTabBarStyle'}
            style={{
              textAlign: 'center',
              cursor: 'pointer',
              padding: '20px',
              fontSize: 16,
              color: activeKey === '2' ? 'rgba(40, 120, 255, 1)' : '',
            }}
          >
            微信客服
          </div>
        </Col>
      </Row>
    </div>
  );
  const items = [
    {
      key: '1',
      label: 'Tab 1',
      children: <TrialForm />,
    },
    {
      key: '2',
      label: 'Tab 2',
      children: <CustomerWX />,
    },
  ];
  return (
    <div className="trial" style={divStyle}>
      <div className="trial_content">
        <div className="trial_content_box">
          <div className="trial_content_bg" />
          <Tabs
            destroyInactiveTabPane={true}
            type="card"
            renderTabBar={renderTabBar}
            tabBarGutter={0}
            activeKey={activeKey}
            style={{ zIndex: 3 }}
            items={items}
          />
        </div>
      </div>
    </div>
  );
};

export default Trial;
